export const INSPECTION_REQUIREMENTS = {
  STANDARD: {display: 'Standard', value: 'Standard', showOrder: 0, def: true},
  VIRTUAL: {display: 'Virtual with iPermit', value: 'Virtual', showOrder: 1, def: false},
  VIRTUAL_WITH_CONTRACTOR: {display: 'Virtual with Contractor', value: 'Virtual with contractor', showOrder: 2, def: false},
  CONTRACTOR_ONSITE: {display: 'Contractor on site', value: 'Contractor on site', showOrder: 3, def: false},
  IPERMIT_SIT_IN: {display: 'iPermit Sit-Ins', value: 'iPermit Sit-Ins', showOrder: 4, def: false},
  IPERMIT_LADDER_DROP_OFF: {display: 'iPermit Ladder Drop Off', value: 'iPermit Ladder Drop Off', showOrder: 5, def: false},
  IPERMIT_SIT_IN_WITH_LADDER: {display: 'iPermit Sit-in+Ladder', value: 'iPermit Sit-in+Ladder', showOrder: 6, def: false},
};


